// extracted by mini-css-extract-plugin
export default {"pointer":"styles_pointer__gMoyg"};